import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utilities/axios';

export const recordVisit = createAsyncThunk('siteVisit/recordVisit', async (_, thunkApi) => {
  try {
    const { data } = await axios.post('/api/record_visit');
    return thunkApi.fulfillWithValue(data);
  } catch {
    return thunkApi.rejectWithValue({ errors: [{ msg: 'something went wrong' }] });
  }
});

const siteVisitSlice = createSlice({
  name: 'siteVisit',
  initialState: { count: 0 },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(recordVisit.fulfilled, (state, action) => {
      state.count = action.payload.count;
    });
  },
});

export default siteVisitSlice.reducer;
